import { Encyclopedia } from '.';
import { AllSpecies } from './encyclopedia.ruleset';

export const encyclopediaGetters = (state: Encyclopedia.State) => ({
  getSpeciesState: (species: AllSpecies) => {
    return state.encyclopedia.speciesState[species] ?? 'veiled';
  },

  getSpeciesNotification: (species: AllSpecies) => {
    return state.encyclopedia.speciesNotification[species] ?? false;
  },
});
